import React from "react";
import Payroll from "./HR/Payroll/Payroll";

export default function PayrollPage() {
  return (
    <div className="px-6 space-y-6 animate-in fade-in duration-300">
      <Payroll />
    </div>
  );
}
